<script lang="ts">
    import { VpCloseIcon } from '@decathlon-experience/icons/svelte';

    export let label: string;
    export let handleRemoveBadgeFilter: () => void;
</script>

<button
    class="flex h-fit w-fit items-center justify-center gap-2xs rounded-full border border-solid border-border-quiet bg-white px-s py-xs text-sm
        transition-colors duration-300 hover:border-border-brand hover:text-content-brand"
    type="button"
    on:click={handleRemoveBadgeFilter}
>
    <span class="whitespace-nowrap">{label}</span>
    <VpCloseIcon class="size-m" />
</button>
